import { render, staticRenderFns } from "./BlocksList.vue?vue&type=template&id=75893f49&scoped=true&"
import script from "./BlocksList.vue?vue&type=script&lang=js&"
export * from "./BlocksList.vue?vue&type=script&lang=js&"
import style0 from "./BlocksList.vue?vue&type=style&index=0&id=75893f49&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75893f49",
  null
  
)

export default component.exports